<template>
	<component
		:is="linkTag"
		:to="isRouterLink ? link : undefined"
		:href="!isRouterLink ? link : undefined"
		class="tile-card"
		:class="{'mini-tile' : miniTile, ['track-' + track]: track}"
		v-on:click="tileClick">

		<div v-if="miniTile" class="mini-tile-content-container">
			<div><i :class="icon"></i></div>
			<div class="count">{{ formattedCount }}</div>
			<div>{{ taskTitle }}</div>
		</div>

		<div v-else class="d-flex" style="height: 100%;width: 100%;">
			<div class="icon-container">
				<i :class="icon" class="fa-2x fa-fw"></i>
			</div>

			<div class="title-container">
				<h5 class="title text-center">
					{{ taskTitle }}
					<div><small v-if="titleSmall">{{titleSmall}}</small></div>
				</h5>
				<div class="count">{{ formattedCount }}</div>
			</div>
		</div>
	</component>
</template>

<script>
export default {
	name: "DashboardTaskPanelTile",
	props: [
		"icon",
		"taskTitle",
		"titleSmall",
		"count",
		"link",
		"buttons",
		"miniTile",
		"track"
	],
	computed: {
		isRouterLink() {
			// If a vue-router location object was passed, or a string without protocol starting with "/" – treat as router-link
			return typeof this.link === "object" || (typeof this.link === "string" && /^\/(?!\/)/.test(this.link));
		},
		linkTag() {
			return this.link ? (this.isRouterLink ? "router-link" : "a") : "div";
		},
		formattedCount() {
			const n = Number(this.count);
			if (!isFinite(n)) return this.count; // already a string etc.
			// Optional: compact format for big values (e.g., 1200 -> 1.2K)
			if (n >= 1000) return (n >= 1000000 ? (n / 1e6).toFixed(n % 1e6 ? 1 : 0) + "M" : (n / 1e3).toFixed(n % 1e3 ? 1 : 0) + "K");
			return String(n);
		}
	},
	methods: {
		tileClick() {
			this.$emit("tileClick")
		},
		buttonClick(action) {
			this.$emit("buttonClick",action)
			this.$emit(action)
		}
	}
};
</script>

<style scoped>
	a.tile-card, div.tile-card {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 8px 15px;
		border-radius: 999px;
		background: #ffffff;
		border: none;
		text-decoration: none;
		color: inherit;
		transition: box-shadow 0.15s ease, transform 0.05s ease;
		margin-right: 10px;
		position: relative;
		cursor: pointer;
	}

	a.tile-card.mini-tile, div.tile-card.mini-tile {
		display: flex;
		flex-direction: row;
		padding: 5px 12px;
	}

	.tile-card:focus,
	.tile-card:hover {
		box-shadow: 0 6px 16px rgba(17, 24, 39, 0.08);
	}

	.tile-card:active {
		transform: translateY(1px);
	}

	.tile-card .title-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;

	}

	.icon-container {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 15px;
		margin-top: 0;
	}

	.title-container .title {
		text-transform: none;
		font-weight: 600;
		font-size: 14px;
		margin-bottom: 0;
	}

	.count {
		font-size: 30px;
		display: block;
		font-weight: 600;
	}

	.mini-tile .count {
		font-size: 20px;
	}

	.mini-tile-content-container {
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 600;
	}

	.mini-tile-content-container .count {
		margin-top: 0;
	}

	.mini-tile-content-container div {
		margin-right: 10px;
		white-space: nowrap;
	}

	.buttons {
		text-align: right;
	}

	.action-container {
		display: flex;
		justify-content: center;
		margin-top: auto;
		width: 100%;
	}

	.action-container .count {
		margin-right: 20px;
	}

	.action-container .buttons {
		display: flex;
		white-space: nowrap;
	}

	.tile-card.track-ops {
		background: var(--ops-track-faded);
	}
	.tile-card.track-ops i {
		color: var(--ops-track-primary);
	}

	.tile-card.track-fin {
		background: var(--fin-track-faded);
	}
	.tile-card.track-fin i {
		color: var(--fin-track-primary);
	}

	.tile-card.track-com {
		background: var(--com-track-faded);
	}
	.tile-card.track-com i {
		color: var(--com-track-primary);
	}

	.tile-card.track-safe {
		background: var(--safe-track-faded);
	}
	.tile-card.track-safe i {
		color: var(--safe-track-primary);
	}
</style>